/**
 * Navigation state-transition logger.
 *
 * Called by NavController every time the XState machine changes value. Two fan-outs:
 *   1. `console.log` — human-readable for developer debugging
 *   2. `window.dispatchEvent(new CustomEvent(TRANSITION_EVENT, {detail}))` —
 *      programmatic observers (Phase 5 analytics will subscribe; smoke tests
 *      assert on this without scraping console output).
 *
 * Both fan-outs fire on every transition — Phase 3 Success Criterion #5 proof
 * artifact.
 */

/** Window event name for navigation transitions. */
export const TRANSITION_EVENT = 'edgewood:nav-transition';

export interface TransitionDetail {
  from: string;
  to: string;
  timestamp: number;
}

export function logTransition(from: string, to: string): void {
  const timestamp = Date.now();
  const iso = new Date(timestamp).toISOString();

  // Console: "[nav] 2026-04-22T15:30:00.000Z idle -> boarding"
  console.log(`[nav] ${iso} ${from} -> ${to}`);

  // Window event: programmatic observers
  if (typeof window !== 'undefined') {
    const detail: TransitionDetail = { from, to, timestamp };
    window.dispatchEvent(new CustomEvent(TRANSITION_EVENT, { detail }));
  }
}
